import * as currencies from 'currency-codes/data';

/**
 * Generates the display string for given currency - e.g. "South African Rand (ZAR)"
 * @param currency - currency code
 * @returns currency display string
 */
export const generateCurrencyDisplay = (currency: string) => {
  if (!currency) return 'No currency set';

  const data = currencies.find((c) => c.code === currency);
  if (!data) return currency;

  return `${data.currency} (${data.code})`;
};
